import TextOptionsQuestionTemplate from '~/pages/anatomyV2/libs/components/TextOptionsQuestionTemplate'
import { TEXT_OPTIONS_CORRECT_ANSWERS } from '~/pages/anatomyV2/libs/textOptionsCorrectAnswers'
import {
  lowerBackPainPNG,
  lowerBackPainWEBP,
} from '~/pages/anatomyV2/lowerBackPain/constants'
import { PageId } from '~/shared/constants/pagesConstants'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 4

const OPTIONS = [
  {
    key: 'lowerBackMuscles',
    i18nKey: 'onboarding.lowerBackPain.options.lowerBackMuscles',
  },
  { key: 'tightHips', i18nKey: 'onboarding.lowerBackPain.options.tightHips' },
  { key: 'weakGlutes', i18nKey: 'onboarding.lowerBackPain.options.weakGlutes' },
]

const LowerBackPainAnatomyV2 = (props: TPageProps) => (
  <TextOptionsQuestionTemplate
    {...props}
    currentSection={SECTION_NUMBER}
    titleI18nKey="onboarding.lowerBackPain.title"
    questionImagePNG={lowerBackPainPNG}
    questionImageWEBP={lowerBackPainWEBP}
    questionImageAlt="Lower back pain"
    options={OPTIONS}
    correctOptionKey={
      TEXT_OPTIONS_CORRECT_ANSWERS[PageId.LOWER_BACK_PAIN_ANATOMY_V2_1]!
    }
    correctTitleI18nKey="onboarding.lowerBackPain.correctTitle"
    correctExplanationI18nKey="onboarding.lowerBackPain.correctExplanation"
    incorrectTitleI18nKey="onboarding.lowerBackPain.incorrectTitle"
    incorrectExplanationI18nKey="onboarding.lowerBackPain.incorrectExplanation"
    question="What causes lower back pain"
  />
)

export default LowerBackPainAnatomyV2
